document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  function toggleContent(tabName) {
    const button = document.querySelector(`[data-tab="${tabName}"]`);
    const content = document.getElementById(tabName);

    if (window.innerWidth <= 849) {
      // Mobile view
      button.classList.toggle("active");
      content.classList.toggle("active");
    } else {
      // Desktop view
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));
      button.classList.add("active");
      content.classList.add("active");
    }
  }

  function initializeTabs() {
    if (window.innerWidth <= 849) {
      // Mobile view
      tabButtons.forEach((button) => {
        const content = button.nextElementSibling;
        button.addEventListener("click", function () {
          content.classList.toggle("active");
          button.classList.toggle("active");
        });
      });
    } else {
      // Desktop view
      tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const tabName = this.getAttribute("data-tab");
          toggleContent(tabName);
        });
      });

      if (tabButtons.length > 0) {
        toggleContent(tabButtons[0].getAttribute("data-tab"));
      }
    }
  }

  initializeTabs();

  window.addEventListener("resize", function () {
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    initializeTabs();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewsText = document.querySelector(".reviews-text");
  const reviewsTabButton = document.querySelector(".review-button");
  const reviewsTabContent = document.querySelector(".review-content");

  if (reviewsText && reviewsTabButton && reviewsTabContent) {
    reviewsText.addEventListener("click", function () {
      document.querySelectorAll(".tab-button").forEach((button) => {
        button.classList.remove("active");
      });
      reviewsTabButton.classList.add("active");

      document.querySelectorAll(".tab-content").forEach((content) => {
        content.classList.remove("active");
      });
      reviewsTabContent.classList.add("active");

      reviewsTabButton.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    });
  }
});
